import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import { capitalize, t } from 'utils';
import styles from './WebhookLog.module.scss';
export interface IWebhookLog extends HTMLAttributes<HTMLDivElement> {
  id?: string;
  eventType?: string;
  eventName?: string;
  createdAt: string;
  isSuccessful?: boolean;
  isFailed?: boolean;
}

const WebhookLog: FC<IWebhookLog> = (props) => {
  const { eventName, eventType, createdAt, isSuccessful, isFailed, className } = props;
  const rootClassName = classNames(styles.root, className, {
    [styles.failed]: isFailed,
  });
  const webHookDate = createdAt?.split(' ')[0].replace(/-/g, '.');
  const webHookTime = createdAt?.split(' ')[1];
  const webHookYear = webHookDate.split('.')[0];
  const webHookMonth = webHookDate.split('.')[1];
  const webHookDay = webHookDate.split('.')[2];
  const formattedDate = `${webHookDay}.${webHookMonth}.${webHookYear}`; // replace this with npm package like dayjs when needed elsewhere
  const webHookDateText = t('webhook.dateAndTime', [
    { key: 'DATE', value: formattedDate },
    { key: 'TIME', value: webHookTime },
  ]);
  const webHookTitle = `${capitalize(eventName ?? '')} ${capitalize(eventType ?? '')}`;
  const webHookStatus = t(`webhook.status.${isSuccessful ? 'success' : 'failed'}`);

  return (
    <div className={rootClassName}>
      <h3 className={styles.title}>{webHookTitle}</h3>
      <p className={styles.status}>{webHookStatus}</p>
      <p className={styles.date}>{webHookDateText}</p>
    </div>
  );
};

export default WebhookLog;
